import { VasttrafikGidHelper } from '../../../helpers/vasttrafik-gid.helper';
import { StopPointType } from '../../../models/stop-point-type.enum';
import type { IStopPoint } from '../../../models/stop-point.model';
import MunicipalityApiModel from './municipality.api-model';

export default class StopPointApiModel {
  public static mapToBusinessModel(apiModel: StopPointApiModel): IStopPoint {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      municipality: apiModel.municipality ? MunicipalityApiModel.mapToBusinessModel(apiModel.municipality) : undefined,
      stopArea: apiModel.stopAreaName
        ? {
            name: apiModel.stopAreaName,
            gid: VasttrafikGidHelper.getStopAreaGidFromStopPointGid(apiModel.gid) ?? '',
            stopPoints: [],
          }
        : undefined,
      stopPointType: StopPointType.unknown,
    };
  }

  gid!: string;
  name!: string;
  shortName!: string;
  stopAreaName!: string;
  municipality!: MunicipalityApiModel;
}
